export const messagesQueryKey = (chatId: string) => ['messages', chatId] as const;
